export enum EventCategoryCode {

  COMPETITION = 'GRA',
  EVENT = 'EVT'

}
